import template from './attendances-by-class.html';

class AttendancesByClassComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, moment,
    AttendanceService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.AttendanceService = AttendanceService;

    this.date = new Date();
    this.attendances = [];
    this.classRoom = {};
    this.fetchData = false;

    this.options = {
      minTime: '06:00',
      maxTime: '23:59',
      slotDuration: '01:00',
      slotWidth: 120
    };
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.categoriesOfDeparture) {
      this.categoriesOfDeparture = Object.assign([], this.categoriesOfDeparture);
    }

    if (changes.classRooms) {
      this.classRooms = Object.assign([], this.classRooms);
    }
  }

  setFilter(form) {
    if (form.$invalid) {
      return false;
    }

    const params = {
      id: this.classRoom.id,
      date: this.moment(this.date).format('YYYY-MM-DD')
    };

    if (this.startTime) {
      params.startTime = this.startTime;
    }

    if (this.endTime) {
      params.endTime = this.endTime;
    }

    this.getAttendances(params);
  }

  getAttendances(params = {}) {
    this.AttendanceService.getByClassRoom(params).then(result => {
      this.attendances = result;
      if (this.attendances.length === 0) {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Brak frekwencji')
            .position('bottom right')
            .hideDelay(3000)
        );
      }
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać frekwencji')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .finally(() => {
        this.fetchData = true;
      });
  }
}

export const AttendancesByClass = {
  bindings: {
    me: '<',
    classRooms: '<',
    categoriesOfDeparture: '<'
  },
  template,
  controller: AttendancesByClassComponent
};
